import {
  SearchOutlined,
  CloseCircleOutlined,
  DownOutlined,
} from '@ant-design/icons';
import { faFolder, faFolderOpen } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Card, Divider, Empty, Flex, Input, Modal, Tree } from 'antd';
import cn from 'classnames';
import { useState } from 'react';

import type { ProductsModalType } from '@app/components/Modals/ProductsModal/types';
import { MultipleSelect } from '@app/components/MultipleSelect';
import { Range } from '@app/shared/components';

import '@app/components/Modals/ProductsModal/styles/ProductsModal.desktop.scss';
const PF = 'products-modal';

export const ProductsModal: ProductsModalType = ({
  isOpen,
  onCancel,
  onOk,
  searchValue,
  onSearch,
  title = 'Выбрать товар',
  showExtraFilters = false,
  suppliersOptions = [],
  skipFilters = () => {},
  onSelect,
  onCheck,
  treeData,
  checkedKeys,
  selectedSuppliers = [],
  setSelectedSuppliers = () => {},
  range = { from: undefined, to: undefined },
  setRange = () => {},
  isLoading = false,
}) => {
  const [isOpenedExtraFilters, setIsOpenedExtraFilters] = useState(false);

  const toggleOpenedExtraFilters = () =>
    setIsOpenedExtraFilters((prev) => !prev);

  return (
    <Modal
      open={isOpen}
      onCancel={onCancel}
      onOk={onOk}
      afterClose={skipFilters}
      title={title}
      okText="Добавить"
      cancelText="Отменить"
      width={900}
      className={PF}
      loading={isLoading}
    >
      <Divider />
      <Flex gap={12} vertical>
        <Flex gap={12}>
          <Input
            addonBefore={<SearchOutlined />}
            placeholder="Введите название, штрихкод или артикул товара"
            value={searchValue}
            onChange={onSearch}
          />
          {showExtraFilters && (
            <Button
              className={`${PF}_arrow_button`}
              icon={
                <DownOutlined
                  className={cn(`${PF}_arrow_icon`, {
                    [`${PF}_arrow_icon_rotate`]: isOpenedExtraFilters,
                  })}
                />
              }
              onClick={toggleOpenedExtraFilters}
            />
          )}
        </Flex>

        {showExtraFilters && (
          <div
            className={cn(`${PF}_extra_filters`, {
              [`${PF}_extra_filters_opened`]: isOpenedExtraFilters,
            })}
          >
            <Flex className={`${PF}_extra_filters_content`} gap={12}>
              <MultipleSelect
                allOptions={suppliersOptions}
                selectedOption={selectedSuppliers}
                setSelectedOptions={setSelectedSuppliers}
                placeholder="Все поставщики"
              />
              <Range label="Цена" values={range} onChange={setRange} />
              <Button
                icon={<CloseCircleOutlined />}
                onClick={skipFilters}
                className={`${PF}_reset`}
              >
                Сброс
              </Button>
            </Flex>
          </div>
        )}
      </Flex>
      <Card className={`${PF}_tree`}>
        {!!treeData?.length ? (
          <Tree
            checkable
            showIcon
            onSelect={onSelect}
            onCheck={onCheck}
            treeData={treeData}
            checkedKeys={checkedKeys}
            expandAction="click"
            icon={({ expanded, isLeaf }) =>
              isLeaf ? null : (
                <FontAwesomeIcon icon={expanded ? faFolderOpen : faFolder} />
              )
            }
          />
        ) : (
          <div className={`${PF}_empty`}>
            <Empty
              className={`${PF}_empty`}
              description="Нет доступных товаров"
            />
          </div>
        )}
      </Card>
      <Divider />
    </Modal>
  );
};
